import { columnForField, defaultColumnWidth } from "../../../Grid/columnForField";
import { kendoDateCell } from "../../../Layout/Grid/Cell/DateCell";
import {
  ttProtectionStateColumnMenu,
  ttProtectionStateEnumCell,
} from "./TTProtectionGridColumnMenu";
import { TTProtectionOverviewItem } from "./TTProtectionOverviewItem";
import { customDecimalFilterCell } from "../../../Layout/Filter/CustomDecimalFilterCell";

export const TTProtectionColumns = () => {
  return [
    columnForField<TTProtectionOverviewItem>("PNr", {
      title: "P-Nr.",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: defaultColumnWidth,
    }),
    columnForField<TTProtectionOverviewItem>("Version", {
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: defaultColumnWidth,
    }),
    columnForField<TTProtectionOverviewItem>("Name", {
      width: defaultColumnWidth,
    }),
    columnForField<TTProtectionOverviewItem>("EffectiveInDate", {
      title: "Effective In Date",
      filter: "date",
      cell: kendoDateCell(),
      width: "220px",
    }),
    columnForField<TTProtectionOverviewItem>("EffectiveOutDate", {
      title: "Effective Out Date",
      filter: "date",
      cell: kendoDateCell(),
      width: "220px",
    }),
    columnForField<TTProtectionOverviewItem>("OverrideTT", {
      title: "Override TT",
      filter: "numeric",
      width: defaultColumnWidth,
    }),
    columnForField<TTProtectionOverviewItem>("OverrideCode", {
      title: "Override Code",
      width: defaultColumnWidth,
    }),
    columnForField<TTProtectionOverviewItem>("OverrideRemark", {
      title: "Override Remark",
      width: defaultColumnWidth,
    }),
    columnForField<TTProtectionOverviewItem>("VersionDate", {
      title: "Version Date",
      filter: "date",
      cell: kendoDateCell(),
      width: "220px",
    }),
    columnForField<TTProtectionOverviewItem>("Status", {
      columnMenu: ttProtectionStateColumnMenu,
      cell: ttProtectionStateEnumCell,
      hideFilterCell: true,
      width: defaultColumnWidth,
    }),
  ];
};
